/**
 * Los pocos tokens que hacen falta en TypeScript.
 *
 * El aspecto vive en `tokens.css` y se consume con `var(--...)`. Aquí solo
 * están los valores que un componente necesita **calcular**: el anillo de
 * progreso de la pantalla 02 se dibuja con un `conic-gradient` cuyo ángulo
 * depende de los datos, y eso no se puede escribir en una hoja de estilos.
 *
 * Duplicar un color aquí y allí es una forma segura de que dejen de coincidir,
 * así que esta lista es deliberadamente corta.
 */

export const color = {
    ink: '#241f1a',
    accent: '#1f6feb',
    ok: '#2e7d5b',
    warn: '#c2571f',
    rec: '#e0362b',
    lineSoft: '#ece3d9',
    bgSubtle: '#f4efe8',
} as const;

export type Color = keyof typeof color;

/**
 * El anillo de "3 de 5 completadas".
 *
 * `conic-gradient(#2e7d5b 0 .6turn, #ece3d9 .6turn 1turn)` con el corte donde
 * toque. Es lo que pide el handoff para la pantalla 02.
 */
export function anilloProgreso(hechas: number, total: number): string {
    const fraccion = total <= 0 ? 0 : Math.min(1, Math.max(0, hechas / total));

    return `conic-gradient(${color.ok} 0 ${fraccion}turn, ${color.lineSoft} ${fraccion}turn 1turn)`;
}

/** Porcentaje entero para el disco interior del anillo. */
export function porcentaje(hechas: number, total: number): number {
    return total <= 0 ? 0 : Math.round((hechas / total) * 100);
}
